import React from 'react';
import {useRef} from 'react';

import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useIntl} from 'react-intl';

export const VideoSection1: React.FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useIntl();
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, amount: 0.3});

  return (
    <section
      ref={ref}
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Full-screen video background */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="/images/stryd5/battery-status.mp4" type="video/mp4" />
        </video>

        {/* Dark overlay for text readability */}
        {/* <div className="absolute inset-0 bg-black/40" /> */}
      </div>

      {/* Text overlay content */}
      <motion.div
        className="relative z-10 text-white lg:text-gray-900 max-w-md ml-auto mr-6 md:mr-12 text-right"
        // initial={{opacity: 0, x: 50}}
        // animate={isInView ? {opacity: 1, x: 0} : {}}
        // transition={{duration: 1, ease: 'easeOut'}}
      >
        <motion.h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight drop-shadow-lg lg:drop-shadow-none"
          // initial={{opacity: 0, x: 30}}
          // animate={isInView ? {opacity: 1, x: 0} : {}}
          // transition={{duration: 0.8, delay: 0.3}}
        >
          {intl.formatMessage({id: 'home.videoSection1.batteryTitle'})}
        </motion.h2>

        <motion.p
          className="text-lg md:text-xl mb-8 leading-relaxed drop-shadow-md lg:drop-shadow-none lg:text-gray-700"
          // initial={{opacity: 0, x: 30}}
          // animate={isInView ? {opacity: 1, x: 0} : {}}
          // transition={{duration: 0.8, delay: 0.5}}
        >
          {intl.formatMessage({id: 'home.videoSection1.batteryDescription'})}
        </motion.p>
      </motion.div>

      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
        // initial={{opacity: 0}}
        // animate={isInView ? {opacity: 1} : {}}
        // transition={{duration: 0.8, delay: 1.2}}
      >
        <motion.div
          animate={{y: [0, 10, 0]}}
          transition={{duration: 2, repeat: Infinity, ease: 'easeInOut'}}
          className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center"
        >
          <div className="w-1 h-3 bg-white/70 rounded-full mt-2" />
        </motion.div>
      </motion.div>
    </section>
  );
};
